import actions from './constants';

export const fetchSubscriptionsSuccess = (response) => ({
  type: actions.FETCH_SUBSCRIPTIONS_SUCCESS,
  response,
});

export const fetchSubscriptionsError = (error) => ({
  type: actions.FETCH_SUBSCRIPTIONS_ERROR,
  error,
});

export const toggleSubscribeSuccess = (event, subscriptions) => ({
  type: actions.TOGGLE_SUBSCRIBE_SUCCESS,
  event,
  subscriptions,
});

export const toggleUnsubscribeSuccess = (event, subscriptions) => ({
  type: actions.TOGGLE_UNSUBSCRIBE_SUCCESS,
  event,
  subscriptions,
});

export const toggleSubscribeError = (event, error) => ({
  type: actions.TOGGLE_SUBSCRIPTION_ERROR,
  event,
  error,
});
